var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.276 3.188C6.196 3.188 6.128 3.164 6.072 3.116C6.024 3.06 6 2.992 6 2.912V2.288C6 2.208 6.024 2.14 6.072 2.084C6.128 2.028 6.196 2 6.276 2H6.984C7.064 2 7.132 2.028 7.188 2.084C7.244 2.14 7.272 2.208 7.272 2.288V2.912C7.272 2.992 7.244 3.06 7.188 3.116C7.132 3.164 7.064 3.188 6.984 3.188H6.276ZM6.372 10.604C6.292 10.604 6.224 10.58 6.168 10.532C6.12 10.476 6.096 10.408 6.096 10.328V4.64C6.096 4.56 6.12 4.496 6.168 4.448C6.224 4.392 6.292 4.364 6.372 4.364H6.9C6.98 4.364 7.044 4.392 7.092 4.448C7.148 4.496 7.176 4.56 7.176 4.64V10.328C7.176 10.408 7.148 10.476 7.092 10.532C7.044 10.58 6.98 10.604 6.9 10.604H6.372Z",
    fill: "#0D1742"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.25,
    stroke: "#0D1742",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.23f8bd137cdf6f8196934e73c4cf3e70.svg";
export { ForwardRef as ReactComponent };